import styled, { css } from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { FlexRow } from "@similarweb/ui-components";

// TODO reuse component from ai-kit when textarea will support onKeyDown event
export const InputWrapper = styled.div`
    display: flex;
    position: relative;
    box-sizing: border-box;
    width: 100%;

    background:
        linear-gradient(white, white) padding-box,
        linear-gradient(270deg, #a8f7cf 0.12%, #a6c0ff 99.77%) border-box;

    border: solid 1px transparent;
    border-radius: 50px;
`;

export const StyledAIInput = styled.textarea`
    height: 40px;
    margin: 0;
    width: 73%;
    box-shadow: none;

    border-radius: 50px;
    box-sizing: border-box;
    background-color: ${colorsPalettes.carbon[0]};
    padding: 12px 16px 12px 48px;
    outline: none;
    border: none;
    z-index: 2;
    resize: none;

    ${setFontVariant("input2", colorsPalettes.carbon[400])}

    &::placeholder {
        ${setFontVariant("input2", colorsPalettes.carbon[200])}
    }

    &:disabled {
        background-color: ${colorsPalettes.carbon[0]};
    }
`;

export const StyledAIcon = styled(SWReactIcons)`
    position: absolute;
    left: 16px;
    top: 50%;
    transform: translateY(-50%);
    width: 24px;
    height: 24px;
    z-index: 3;
`;

export const ButtonWrapper = styled.div`
    position: absolute;
    top: 10px;
    z-index: 10;
    right: 16px;

    .customTooltip {
        width: 230px;
        word-break: break-all;
    }
`;

const Divider = styled.span`
    background: ${colorsPalettes.carbon[200]};

    height: 100%;
    width: 1px;
    position: absolute;
    left: -5px;
`;

export const RefineButtonWrapper = styled(FlexRow)`
    align-items: center;
`;

export const StyledAIIcon = styled(SWReactIcons)<{ isDisabled: boolean }>`
    ${({ isDisabled }) =>
        isDisabled &&
        css`
            opacity: 0.33;
        `}
`;

export const TooltipContent = styled.div`
    width: 170px;
`;
